import { KatBookURL, KatBookURLs, LocalURL, LoginURL, LoginURLss, URLKpostLogin } from './URL'



export async function getCountrylist() {
  try {
    const response = await fetch(`${URLKpostLogin}/common/countries`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 201) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function LoginKpostAPI(body) {
  try {
    const response = await fetch(`${URLKpostLogin}/common/getCompanyDetails`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    throw new Error(error)
  }
}

export async function FetchKpostId(body) {
  try {
    const response = await fetch(`${URLKpostLogin}/signupLogin/fetchUserDetails`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    throw new Error(error)
  }
}

export async function LoginKpost(body) {
  try {
    const response = await fetch(`${URLKpostLogin}/signupLogin/userLogin`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export const postalPincode = async (body) => {
  console.log(body, 'testsce')
  try {
    const response = await fetch(`${URLKpostLogin}/common/postalPinCode`, {
      method: `post`,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (response.status === 401 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (e) {
    throw e
  }
}

// Forget Password

export async function ForgetPasswordSentOTP(body) {
  try {
    const response = await fetch(`${LoginURL}/admin/forgot-password/otp`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 401 || response.status === 400 || response.status === 404) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function ForgetPasswordOTPVerify(body) {
  try {
    const response = await fetch(`${URLKpostLogin}/common/validateOTP`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 401 || response.status === 400 || response.status === 404) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}


export async function ForgetPasswordUpdate(body) {
  try {
    const response = await fetch(`${URLKpostLogin}/common/forgotPasswordUpdate`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 401 || response.status === 400 || response.status === 404) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}
export async function LoginAPI(body) {
  try {
    const response = await fetch(
      `${LoginURL}/user/login`,
      {
        method: `POST`,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      },
    )
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function FetcUserData(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/user/fetch-data`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}

export async function LoginByKPOSTID(body) {
  try {
    const response = await fetch(`${LoginURL}/admin/login`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500 || response.status === 401 || response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}




export async function getCountryList() {
  try {
    // const response = await fetch(`${LoginURL}/countries/getAll`, {
    const response = await fetch(`${URLKpostLogin}/common/countries`,
       {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}

export async function createCompanyList(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/institution`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}

export async function UpdateCompanylist(body, companyId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/institution/${companyId}`, {
      method: `PUT`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}



export async function GetCompanylist() {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/institution`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}

export async function GetCompanyByIdlist(companyId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/institution/${companyId}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}


export async function Getspecialityist() {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/specialities/getAll`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}


export async function SaveCompanySpeciality(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/specialities/map-company`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}



export async function GetInvoicelist(companyId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/institution-invoice/${companyId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}

export async function GetCompanyMappingList(companyId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/specialities/map-company/${companyId}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}

export async function uploadpfdtoApi(body) {
  const token = JSON.parse(localStorage.getItem("accessToken"));

  try {
    const response = await fetch(`${LoginURLss}/assets/cf/upload`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: body,
    });

    const data = await response.json();

    // Return response data for all expected status codes
    if ([200, 201, 400, 401, 403, 404, 409, 500].includes(response.status)) {
      return data;
    }

    // Handle unexpected status codes
    throw new Error(data?.error || "Something went wrong");

  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
}

export const ChangePasswordAPI = async (body) => {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/admin/change-password`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}


export async function uploadLogoToApi(body) {
    const token = JSON.parse(localStorage.getItem("accessToken"));

  try {
    const response = await fetch(`${LoginURLss}/assets/stream/image-list`, {
       headers: {
        Authorization: `Bearer ${token}`,
      },
      method: "POST",
      body: body,
    });

    const data = await response.json();

    if (response.status === 200 || response.status === 201) {
      return data;
    }
    else if (
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return data;
    }
    else {
      throw new Error(data?.error || "Something went wrong");
    }

  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
}


export async function ToggleUserBlockStatus(userId, block) {
    const token = JSON.parse(localStorage.getItem("accessToken"));

  try {
    const response = await fetch(`${LoginURL}/user/block-status/${userId}/${block}`, {
       headers: {
        Authorization: `Bearer ${token}`,
      },
      method: "PATCH",
      // body: body,
    });

    const data = await response.json();

    if (response.status === 200 || response.status === 201) {
      return data;
    }
    else if (
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return data;
    }
    else {
      throw new Error(data?.error || "Something went wrong");
    }

  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
}

export async function SaveAdvertisement(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/advertisements/add`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });

    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}


export async function GetAdvertisementlist(companyId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/advertisements/${companyId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}

export async function GetUserlist(companyId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/admin/${companyId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}


export async function JournalAdminUser(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/admin/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });

    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}


export async function DeleteAdvertisement(advertisementId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/advertisements/${advertisementId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}

export const DeleteCompanySpeciality = async (mappingId) => {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/specialities/map-company/${mappingId}`, {
      method: `DELETE`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}


export async function GetUserDetailsList(companyId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/user/get?companyId=${companyId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}


export async function DeleteUserList(userId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/user/block-status/${userId}/true`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}

export async function DeleteAdminList(userId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/admin/block-status/${userId}/true`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}



export async function DeleteCompanyList(companyId,body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/institution/${companyId}/block`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
            body: JSON.stringify(body),

    })

    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}

export async function ActivateUserList(userId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/user/block-status/${userId}/false`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}



export async function ActivateCompanyList(companyId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/companies/block-status/${companyId}/false`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}






export async function ActivateAdminList(userId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/admin/block-status/${userId}/false`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}


export async function Updateavertisement(body, id) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/advertisements/update/${id}`, {
      method: `PATCH`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}


export async function GetSpecialityUserDetailsList(companyId, specialityId = null) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'));

    // Build URL — append specialityId only if provided
    const url = specialityId
      ? `${LoginURL}/user/get?companyId=${companyId}&specialityId=${specialityId}`
      : `${LoginURL}/user/get?companyId=${companyId}`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (
      response.status === 200 ||
      response.status === 201 ||
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json();
    } else {
      const errorResponse = await response.json();
      throw new Error(errorResponse.error);
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message);
  }
}


export async function AddPrice(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/speciality-pricing/add`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });

    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}


export async function Addcompanyinvoicelist(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/institution-invoice`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });

    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}


export async function GetPrice() {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/speciality-pricing/get`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}


export async function UpdatePrice(body, specialityId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/speciality-pricing/update/${specialityId}`, {
      method: `PATCH`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}


export async function GetLicenseRequestslist() {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/license-request`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}

export async function UpdateLicenseRequestStatus(body, licenseRequestId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/license-request/${licenseRequestId}`, {
      method: `PATCH`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}

export async function CreateUser(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/user/create`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message)
  }
}

export async function GetUserBulkTemplate() {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/user/bulk/template`, {
      method: `GET`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      // Excel binary — do not parse as JSON
      const blob = await response.blob()
      return { status: response.status, blob }
    } else {
      const errorResponse = await response.json()
      return { status: response.status, error: errorResponse?.error || 'Failed to download template' }
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message)
    return { status: 500, error: error.message }
  }
}

// ── Bulk Upload: Upload Filled Excel ──────────────────────────────
// POST api/v1/user/bulk/upload (multipart/form-data — file only, no Content-Type header)
export async function UploadUserBulkFile(formData) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/user/bulk/upload`, {
      method: `POST`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message)
  }
}

// ── Get All Users ──────────────────────────────────────────────────
// GET api/v1/user/getAll
export async function GetAllUsers() {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/user/getAll`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message)
  }
}

// ── Get Users of a Particular Institution ──────────────────────────
// GET api/v1/user/:institutionId
export async function GetUsersByInstitution() {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const institutionId = JSON.parse(localStorage.getItem('companyId'))
    const response = await fetch(`${LoginURL}/user/${institutionId}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message)
  }
}
// ── Book Mapping : Filter tiers & variables ────────────────────────
// GET api/v1/filter/tiervariable-names/?categoryId=:categoryId[&institutionId=:institutionId]
// Passing institutionId narrows the tiers to that publisher's books; it is left
// off entirely when no publisher is selected.
export async function GetBookFilters(categoryId, institutionId = '') {
  try {
    const response = await fetch(
      `${KatBookURLs}/filter/medical/tiervariable-names?bookDomainId=${categoryId}${
        institutionId ? `&institutionId=${institutionId}` : ''
      }`,
      {
        method: `GET`,
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message)
  }
}

// ── Book Mapping : Publishers (institutions) of a category ─────────
// GET api/v1/filter/institutions/:categoryId
export async function GetPublishers(categoryId) {
  try {
    const response = await fetch(`${KatBookURLs}/filter/institutions/medical/${categoryId}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message)
  }
}

// ── Book Mapping : Books of a category ─────────────────────────────
// POST api/v2/filter/books?limit=:pageSize&start=:pageNumber
// Filters travel in the body, paging in the query string. The response carries
// data, currentPage, totalPages, totalItems and itemsPerPage.
export async function GetBooksByCategory({
  categoryId,
  limit = 30,
  start = 1,
  institutionId = '',
  bookDetailFilters = [],
  yearId = '',
} = {}) {
  try {
    const response = await fetch(
      `${KatBookURLs}/filter/medical/books?start=${start}&limit=${limit}`,
      {
        method: `POST`,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          domainId: [categoryId],
          bookDetailFilters,
        }),
      },
    )
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message)
  }
}

// ── Book Mapping : books already mapped to institutions ────────────
// GET api/v1/institution-book?institutionIds=:ids&matchMode=:mode
export async function GetInstitutionBooks(institutionIds = [], matchMode = 'any', options = {}) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const ids = Array.isArray(institutionIds) ? institutionIds.join(',') : institutionIds
    // Optional paging (the endpoint already supports page and limit); omitted by default.
    const extra = ['page', 'limit']
      .filter((key) => options?.[key] !== undefined)
      .map((key) => `&${key}=${options[key]}`)
      .join('')
    const response = await fetch(
      `${LoginURL}/institution-book?institutionIds=${ids}&matchMode=${matchMode}${extra}`,
      {
        method: `GET`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      },
    )
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 405 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message)
  }
}

// ── Book Mapping : map selected books to institutions ──────────────
// POST api/v1/institution-book/map
export async function MapInstitutionBooks(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/institution-book/map`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 405 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message)
  }
}

// ── Book Mapping : remove books from institutions ──────────────────
// POST api/v1/institution-book/unmap
export async function UnmapInstitutionBooks(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/institution-book/unmap`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 405 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message)
  }
}

// ── Book Mapping : books mapped to the logged in user's institution ─
// GET api/v1/institution-book/my-institution
export async function GetMyInstitutionBooks() {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/institution-book/my-institution`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 405 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message)
  }
}

// ── Website Content Management : add a section ─────────────────────
export async function CreateWebsiteSection(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/website-content/section`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 405 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message)
  }
}

export async function GetWebsiteSections() {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/website-content/section`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 405 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message)
  }
}

export async function GetWebsiteSectionById(sectionId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/website-content/section/${sectionId}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 405 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message)
  }
}

export async function UpdateWebsiteSection(body, sectionId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/website-content/section/${sectionId}`, {
      method: `PUT`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 405 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message)
  }
}

export async function PublishWebsiteSection(sectionId, publish) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(
      `${LoginURL}/website-content/section/${sectionId}/publish/${publish === true}`,
      {
        method: `PATCH`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      },
    )
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 405 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message)
  }
}

export async function DeleteWebsiteSection(sectionId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/website-content/section/${sectionId}`, {
      method: `DELETE`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 405 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message)
  }
}

// ── Website Content Management : section items ─────────────────────
export async function CreateSectionItem(sectionId, body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/website-content/section/${sectionId}/item`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 405 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message)
  }
}

export async function GetSectionItems(sectionId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/website-content/section/${sectionId}/item`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (response.status === 404) {
      // A section without items answers 404: treat it as an empty list
      return { success: true, data: [] }
    } else if (
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 405 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message)
  }
}

export async function ReorderSectionItems(sectionId, itemIds) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/website-content/section/${sectionId}/item/reorder`, {
      method: `PATCH`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ itemIds }),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 405 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message)
  }
}

export async function UpdateSectionItem(itemId, body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/website-content/item/${itemId}`, {
      method: `PUT`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 405 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message)
  }
}

export async function PublishSectionItem(itemId, publish) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(
      `${LoginURL}/website-content/item/${itemId}/publish/${publish === true}`,
      {
        method: `PATCH`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      },
    )
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 405 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message)
  }
}

export async function DeleteSectionItem(itemId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/website-content/item/${itemId}`, {
      method: `DELETE`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 405 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message)
  }
}

// ── Website Content : public site ──────────────────────────────────
// GET api/v1/website-content  (every live section, no token)
export async function GetPublicWebsiteContent() {
  try {
    const response = await fetch(`${LoginURL}/website-content`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message)
  }
}

// GET api/v1/website-content/key/:sectionKey  (one live section, no token)
export async function GetPublicWebsiteSectionByKey(sectionKey) {
  try {
    const response = await fetch(`${LoginURL}/website-content/key/${sectionKey}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message)
  }
}

// ── Notifications : the header bell ────────────────────────────────
// GET api/v1/notifications?page=:page&limit=:limit  (the signed-in admin's
// notifications, read and unread, newest first). Both are optional: the API
// defaults to page 1 of 20 and serves at most 50 a page.
export async function GetNotifications({ page, limit } = {}) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const query = new URLSearchParams()
    if (page !== undefined) query.set('page', page)
    if (limit !== undefined) query.set('limit', limit)
    const search = query.toString() ? `?${query}` : ''

    const response = await fetch(`${LoginURL}/notifications${search}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message)
  }
}

// GET api/v1/notifications/unread-count  (the red badge on the bell)
export async function GetUnreadNotificationCount() {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/notifications/unread-count`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message)
  }
}

// PATCH api/v1/notifications/read-all  ("Mark all as read" in the dropdown)
export async function MarkAllNotificationsRead() {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/notifications/read-all`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message)
  }
}

// PATCH api/v1/notifications/:id/read  (one notification, when it is clicked)
export async function MarkNotificationRead(notificationId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/notifications/${notificationId}/read`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message)
  }
}
